import React from 'react'
import PropTypes from 'prop-types'
import axios from 'axios'
import Button from './Button'
import Alert from './Alert'

export class CustomerForm extends React.Component {
  constructor() {
    super()
    this.state = {}
    this.handleSubmit = this.handleSubmit.bind(this)
  }
  handleSubmit(e) {
    const that = this
    e.preventDefault()
    this.setState({
      loading: true,
      feedback: null,
    })
    axios.post('/api/subscribe', {
      email_address: e.target.email.value,
    }).then((response) => {
      if (response.data.success) {
        that.setState({
          loading: false,
          feedback: {
            message: response.data.feedback.message,
            type: response.data.feedback.type,
          },
        })
      } else {
        that.setState({
          loading: false,
          feedback: {
            message: response.data.feedback.message,
            type: response.data.feedback.type,
          },
        })
      }
    }).catch((err) => {
      that.setState({
        loading: false,
        feedback: {
          message: response.data.feedback.message,
          type: response.data.feedback.type,
        },
      })
    })
  }
  render() {
    return (
      <div>
      <div className={`w-100 ${this.props.centered ? 'd-flex justify-content-center' : ''}`}>
        <form onSubmit={this.handleSubmit} className="w-100" style={{ maxWidth: 445 }}>
          <div className="form-group">
            {this.props.showCustomLabel === true ?
              <label className="text-white" htmlFor="email">
                Informe seu e-mail para solicitar uma apresentação
              </label>
              : null}
            <div className="d-flex form-flex-couple" style={{ boxShadow: '0 0px 1px rgba(0, 0, 0, 0.12), 0 0px 1px rgba(0, 0, 0, 0.24)' }}>
              <input type="email" name="email" className="form-control" style={{ flex: 1 }} required />
              <div>
                <Button campaign centered={this.props.centered}>{this.state.loading ? 'Enviando...' : 'Solicitar'}</Button>
              </div>
            </div>
          </div>
        </form>
      </div>
      {this.state.feedback ? (
        <Alert type={this.state.feedback.type}>
          {this.state.feedback.message}
        </Alert>
      ) : null}
      </div>
    )
  }
}

CustomerForm.propTypes = {
  centered: PropTypes.bool,
  showCustomLabel: PropTypes.bool,
}

export default CustomerForm



// WEBPACK FOOTER //
// ./client/components/CustomerForm.js